import React, { useState, useCallback } from 'react';

const PreviewContext = React.createContext();

export const PreviewProvider = (props) => {
  const [previewType, setPreviewType] = useState('company');
  const [isPreviewOpen, setIsPreviewOpen] = useState(false);
  const [bookletCompanyPreview, setBookletCompanyPreview] = useState(null);
  const [couponsToPreview, setCouponsToPreview] = useState(null);
  const [modalCompanyPreview, setModalCompanyPreview] = useState(null);

  // Helper function to reset preview when changing sources
  const resetPreview = useCallback(() => {
    setCouponsToPreview(null);
    setModalCompanyPreview(null);
    setBookletCompanyPreview(null);
  }, []);

  // Set preview from companies table
  const setPreviewFromBooklet = useCallback((bookletId, companyId, coupons = null) => {
    resetPreview();
    setBookletCompanyPreview({ bookletId, companyId });
    if (coupons) setCouponsToPreview(coupons);
    setIsPreviewOpen(true);
    setPreviewType('company');
  }, [resetPreview]);

  // Set preview from modal
  const setPreviewFromModal = useCallback((company, coupons = null) => {
    resetPreview();
    setModalCompanyPreview(company);
    if (coupons) setCouponsToPreview(coupons);
    setIsPreviewOpen(true);
    setPreviewType('company');
  }, [resetPreview]);

  const context = {
    previewType,
    setPreviewType,
    isPreviewOpen,
    setIsPreviewOpen,
    bookletCompanyPreview,
    setBookletCompanyPreview,
    couponsToPreview,
    setCouponsToPreview,
    modalCompanyPreview,
    setModalCompanyPreview,
    setPreviewFromBooklet,
    setPreviewFromModal,
    resetPreview,
  };

  return (
    <PreviewContext.Provider value={context}>
      {props.children}
    </PreviewContext.Provider>
  );
};

export const usePreviewContext = () => React.useContext(PreviewContext);
